export default __webpack_public_path__ + "static/media/img-slider-banpu-power-5.5a5ba9e3.png";